// extracted by mini-css-extract-plugin
export default {"outer":"GkRrG","select":"_f8HP"};